module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/hexagon-552f4015dd7bca1517d6c9a8ed3441e6.png";